export enum ApiUserStorageUrls {
  GetValue = '/api/v1.0/storage/userstorage/getvalue',
  GetAllData = '/api/v1.0/storage/userstorage/getuserstorage',
  UpdateValue = '/api/v1.0/storage/userstorage/updatevalue',
  DeleteValue = '/api/v1.0/storage/userstorage/deletevalue',
  DeleteAllData = '/api/v1.0/storage/userstorage/delete',
}
